import { folderColorValue } from '@lib/library/folderPath';
import FolderOpenRounded from '@mui/icons-material/FolderOpenRounded';
import FolderRounded from '@mui/icons-material/FolderRounded';

/** A folder in its colour. `open` for the folder being looked at, or the one a drag is over. */
export function FolderGlyph({
  color,
  open = false,
  size = 20,
}: {
  color?: string;
  open?: boolean;
  size?: number;
}) {
  const Glyph = open ? FolderOpenRounded : FolderRounded;
  return <Glyph sx={{ fontSize: size, color: folderColorValue(color), flexShrink: 0 }} />;
}
